function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BermudaFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#AF0100",
      fillRule: "evenodd",
      d: "M0 3v18h24V3H0Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("mask", {
      id: "b",
      width: "24",
      height: "18",
      x: "0",
      y: "3",
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: 'luminance'
      },
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 3v18h24V3H0Z",
        clipRule: "evenodd"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#b)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#F7FCFF",
        fillRule: "evenodd",
        d: "M16.506 12c0 4.415.418 5.948 2.934 5.948s3.205-2.224 2.992-5.948h-5.926Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#AF0100",
        fillRule: "evenodd",
        d: "M19.575 14.55c.704 0 1.275-.672 1.275-1.5s-.57-1.5-1.275-1.5c-.704 0-1.275.672-1.275 1.5s.57 1.5 1.275 1.5Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#5EAA22",
        fillRule: "evenodd",
        d: "M17.095 16.735c.448 1 1.232 1.5 2.353 1.5 1.112 0 1.899-.493 2.36-1.48l-4.713-.02Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#82B2CB",
        d: "m17.714 14.273-.418-1.044c.768-.308 1.509-.464 2.22-.464.712 0 1.453.156 2.222.464l-.42 1.044c-.64-.257-1.24-.383-1.801-.383-.562 0-1.162.126-1.803.383Z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#FECA00",
        fillRule: "evenodd",
        d: "M18.75 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#8A4E22",
        fillRule: "evenodd",
        d: "M19.2 16.2a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#AF0100",
        fillRule: "evenodd",
        d: "M18 15.6a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM20.55 15.6a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM20.025 17.25c.29 0 .525-.336.525-.75s-.235-.75-.525-.75c-.29 0-.525.336-.525.75s.235.75.525.75ZM18.225 17.25c.29 0 .525-.336.525-.75s-.235-.75-.525-.75c-.29 0-.525.336-.525.75s.235.75.525.75Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#2E42A5",
        d: "M0 3h13.5v10.5H0z"
      }), /*#__PURE__*/_jsx("mask", {
        id: "c",
        width: "14",
        height: "11",
        x: "0",
        y: "3",
        maskUnits: "userSpaceOnUse",
        style: {
          maskType: 'luminance'
        },
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 3h13.5v10.5H0z"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#c)",
        children: [/*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "m-1.503 12.75 2.97 1.303 12.1-9.636 1.567-1.937-3.176-.435-4.936 4.152L3.05 8.995l-4.553 3.755Z"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#F50100",
          d: "m-1.097 13.663 1.514.756L14.572 2.3h-2.125L-1.097 13.663Z"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "m15.003 12.75-2.97 1.303-12.1-9.636-1.567-1.937 3.176-.435 4.936 4.152 3.972 2.798 4.553 3.755Z"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#F50100",
          d: "m14.902 13.405-1.514.756-6.027-5.188-1.787-.58-7.36-5.906H.34l7.355 5.766 1.954.695 5.253 4.457Z"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M5.5 2.5V2H5v.5h.5Zm0 3.799v.5H6v-.5h-.5Zm-5.988 0v-.5h-.5v.5h.5Zm0 4h-.5v.5h.5v-.5Zm5.988 0H6v-.5h-.5v.5ZM5.5 14H5v.5h.5V14ZM8 14v.5h.5V14H8Zm0-3.701v-.5h-.5v.5H8Zm6.012 0v.5h.5v-.5h-.5Zm0-4h.5v-.5h-.5v.5ZM8 6.299h-.5v.5H8v-.5ZM8 2.5h.5V2H8v.5ZM7 6.299v.5h.5v-.5H7ZM7 3.5h.5V3H7v.5Zm-.5 0V3H6v.5h.5Zm0 2.799H6v.5h.5v-.5Zm.5 1h.5v-.5H7v.5Zm-.5 0v-.5H6v.5h.5Zm.5 2v.5h.5v-.5H7Zm-.5 0H6v.5h.5v-.5Zm-1-2H6v-.5h-.5v.5Zm-4.988 0v-.5h-.5v.5h.5Zm0 2h-.5v.5h.5v-.5Zm4.988 0v.5H6v-.5h-.5Zm1 1v-.5H6v.5h.5ZM6.5 13H6v.5h.5V13Zm.5 0v.5h.5V13H7Zm0-2.701h.5v-.5H7v.5Zm1-3v-.5h-.5v.5H8Zm0 2h-.5v.5H8v-.5Zm5.012-2h.5v-.5h-.5v.5Zm0 2v.5h.5v-.5h-.5ZM5.5 3H6V2h-.5v1ZM6 3v-.5H5V3h1Zm0 3.299V3H5v3.299h1Zm-5.988.5H5.5v-1H.012v1Zm-.5 0h.5v-1h-.5v1Zm.5 0v-.5h-1v.5h1Zm0 3v-3h-1v3h1Zm0 .5v-.5h-1v.5h1Zm0-.5h-.5v1h.5v-1Zm5.488 0H.012v1H5.5v-1ZM6 13.5v-3.201H5V13.5h1Zm0 .5v-.5H5v.5h1Zm0-.5h-.5v1H6v-1Zm1.5 0H6v1h1.5v-1Zm.5 0h-.5v1H8v-1Zm-.5 0v.5h1v-.5h-1Zm0-3.201V13.5h1v-3.201h-1Zm6.012-.5H8v1h5.512v-1Zm.5 0h-.5v1h.5v-1Zm-.5 0v.5h1v-.5h-1Zm0-3v3h1v-3h-1Zm0-.5v.5h1v-.5h-1Zm0 .5h.5v-1h-.5v1ZM8 6.799h5.512v-1H8v1ZM7.5 3v3.299h1V3h-1Zm0-.5V3h1v-.5h-1Zm0 .5H8V2h-.5v1ZM6 3h1.5V2H6v1Zm1.5 3.299V3.5h-1v2.799h1ZM7 3h-.5v1H7V3Zm-1 .5v2.799h1V3.5H6Zm.5 3.299H7v-1h-.5v1Zm.5 0h-.5v1H7v-1Zm.5 2.5v-2h-1v2h1Zm-1 .5H7v-1h-.5v1Zm-.5-2.5v2h1v-2H6Zm-.5-.5H.512v1H5.5v-1Zm-5.488.5v2h1v-2h-1Zm.5 2.5H5.5v-1H.512v1ZM6 9.299v-2H5v2h1Zm0 1V13h1v-2.701H6Zm.5 3.201H7v-1h-.5v1Zm1-.5v-2.701h-1V13h1ZM7 9.799h-.5v1H7v-1Zm.5-2.5v2h1v-2h-1Zm5.512-.5H8v1h5.012v-1Zm.5 2.5v-2h-1v2h1ZM8 9.799h5.012v-1H8v1Z"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#F50100",
          fillRule: "evenodd",
          d: "M7.5 3H6v3.799H.012v3H6V13.5h1.5V9.799h6.012v-3H7.5V3Z",
          clipRule: "evenodd"
        })]
      })]
    })]
  })]
}));
//# sourceMappingURL=Bermuda.js.map